/**
 * Blog
 */

import loadMoreArticles from '../lib/load-more-articles';

loadMoreArticles();
